export const REVISION_PERIOD_DAYS = 14;
export const WEEK_BEFORE_TERM_START_DAYS = 7;
